export const plans = [
  {
    name: 'Premium',
    description:
      'Aulas Particulares (1 por semana ou 52 por ano) + Intercâmbio',
    recurrencies: [
      {
        price: 427,
        description: 'Mensal com 36% OFF',
        months: 1,
        paymentType: 'creditCard',
        frequency: 'mensal',
        id: 22,
      },
      {
        price: 427,
        description: 'Mensal com 36% OFF',
        months: 1,
        paymentType: 'bankSlip',
        frequency: 'mensal',
        id: 27,
      },
    ],
    legalTerms: [],
    trial: null,
    informationProduct:
      'O ciclo completo da fluência: Escola online + Aula particular + Conversação ilimitada + Intercâmbio.',
    internalName: 'Premium 52',
    id: 2,
  },
  {
    name: 'Professional',
    description: 'Aulas Particulares (1 por semana ou 52 por ano)',
    recurrencies: [
      {
        price: 239,
        description: 'Anual com 45% OFF',
        months: 12,
        paymentType: 'creditCard',
        frequency: 'anual',
        id: 20,
      },
      {
        price: 437,
        description: 'Mensal sem desconto',
        months: 1,
        paymentType: 'creditCard',
        frequency: 'mensal',
        id: 21,
      },
      {
        price: 239,
        description: 'Anual com 45% OFF',
        months: 12,
        paymentType: 'bankSlip',
        frequency: 'anual',
        id: 25,
      },
      {
        price: 239,
        description: 'Mensal com desconto',
        months: 1,
        paymentType: 'bankSlip',
        frequency: 'mensal',
        id: 26,
      },
    ],
    legalTerms: [],
    trial: null,
    informationProduct:
      'Turbine a prática do seu inglês. Escola online + Aula particular + Conversação em grupo ilimitada.',
    internalName: 'Professional 52',
    id: 3,
  },
  {
    name: 'Basic',
    description: 'Aulas',
    recurrencies: [
      {
        price: 149,
        description: 'Anual com 42% OFF',
        months: 12,
        paymentType: 'creditCard',
        frequency: 'anual',
        id: 11,
      },
      {
        price: 257,
        description: 'Mensal sem desconto',
        months: 1,
        paymentType: 'creditCard',
        frequency: 'mensal',
        id: 13,
      },
      {
        price: 149,
        description: 'Anual com 42% OFF',
        months: 12,
        paymentType: 'bankSlip',
        frequency: 'anual',
        id: 29,
      },
    ],
    legalTerms: [],
    trial: null,
    informationProduct:
      'Escola de inglês online que te leva do zero a fluência em tempo recorde.',
    internalName: 'Basic',
    id: 4,
  },
  {
    name: 'Premium',
    description: 'Aulas Particulares (2 por mês ou 24 por ano) + Intercâmbio',
    recurrencies: [
      {
        price: 387,
        description: 'Anual com 47% OFF',
        months: 1,
        paymentType: 'creditCard',
        frequency: 'mensal',
        id: 17,
      },
      {
        price: 387,
        description: 'Mensal com 36% OFF',
        months: 1,
        paymentType: 'bankSlip',
        frequency: 'mensal',
        id: 28,
      },
    ],
    legalTerms: [],
    trial: null,
    informationProduct:
      'O ciclo completo da fluência: Escola online + Aula particular + Conversação ilimitada + Intercâmbio.',
    internalName: 'Premium 24',
    id: 7,
  },
  {
    name: 'Professional',
    description: 'Aulas Particulares (2 por mês ou 24 por ano)',
    recurrencies: [
      {
        price: 189,
        description: 'Anual com 47% OFF',
        months: 12,
        paymentType: 'creditCard',
        frequency: 'anual',
        id: 18,
      },
      {
        price: 357,
        description: 'Mensal sem desconto',
        months: 1,
        paymentType: 'creditCard',
        frequency: 'mensal',
        id: 19,
      },
      {
        price: 189,
        description: 'Anual com 47% OFF',
        months: 12,
        paymentType: 'bankSlip',
        frequency: 'anual',
        id: 23,
      },
      {
        price: 189,
        description: 'Mensal com desconto',
        months: 1,
        paymentType: 'bankSlip',
        frequency: 'mensal',
        id: 24,
      },
    ],
    legalTerms: [],
    trial: null,
    informationProduct:
      'Turbine a prática do seu inglês. Escola online + Aulas particulares + Conversação ilimitada.',
    internalName: 'Professional 24',
    id: 8,
  },
];

export const plan = {
  name: 'Basic',
  description: 'Aulas',
  recurrencies: [
    {
      price: 149,
      description: 'Anual com 42% OFF',
      months: 12,
      paymentType: 'creditCard',
      frequency: 'anual',
      id: 11,
    },
    {
      price: 257,
      description: 'Mensal sem desconto',
      months: 1,
      paymentType: 'creditCard',
      frequency: 'mensal',
      id: 13,
    },
    {
      price: 149,
      description: 'Anual com 42% OFF',
      months: 12,
      paymentType: 'bankSlip',
      frequency: 'anual',
      id: 29,
    },
  ],
  legalTerms: [],
  trial: null,
  informationProduct:
    'Escola de inglês online que te leva do zero a fluência em tempo recorde.',
  internalName: 'Basic',
  id: 4,
  identifier: 'ZXkxWJlHLAk',
};

export const plansIcon = {
  class: '/Others/Icons/icon-class-2x-64x64_udotmm',
  talk: '/Others/Icons/icon-talk-2x-64x64_k3krgd',
  abroad: '/Others/Icons/pass-2x-64x64_jp5ozc?w=128',
};

export const IconsNeon = {
  abroad: '/Black%20November/abroad_btzfpy',
  class: '/Black%20November/class_xypzkk',
  talk: '/Black%20November/talk_h70sm7',
};

export const plansIconHighlight = {
  class: '/Others/Icons/icon-class-branco-2x-48x48_pkmjpi',
  talk: '/Others/Icons/icon-talk-branco-2x-48x48_ilenev',
  abroad: '/Others/Icons/icon-pass-branco-2x-48x48_rpiwzm',
};

export const BirthdayHeroImage =
  'https://res.cloudinary.com/intercambiodireto-com/image/upload/f_auto/v1718315631/Others/backgrounds/background_aniversario_bx0pvs';

export const MobileBirthdayHeroImage =
  'https://res.cloudinary.com/intercambiodireto-com/image/upload/f_auto/v1718631858/Others/backgrounds/bg_banner_8anos_qkgyhz';

export const birthdayGradient = {
  backgroundColor: '#E9E0CD',
  background:
    'radial-gradient(circle farthest-corner at center center, #E9E0CD 0%, #BA8963 100%)',
  '-webkit-background-clip': 'text',
  '-webkit-text-fill-color': 'transparent',
};
